'use client';

import { Skeleton } from '@abyss/web/ui/Skeleton';
import { Flex } from '@abyss/web/ui/Flex';
import { Grid } from '@abyss/web/ui/Grid';
import { Layout } from '@abyss/web/ui/Layout';
import { Divider } from '@abyss/web/ui/Divider';

const FormSkeleton = () => {
  return (
    <>
      <div style={{ height: '20px' }}></div>
      <Flex justify="space-between" direction="row">
        <Skeleton variant="rounded" width={450} height={50} />
        <Skeleton variant="rounded" width={200} height={50} />
      </Flex>
      <div style={{ height: '20px' }}></div>
      <Flex>
        <Skeleton variant="rounded" width={1000} height={30} />
      </Flex>
      <div style={{ height: '20px' }}></div>
      <div style={{ height: '45px' }}>
        <Divider />
      </div>
      <Layout.Stack space={25} grow>
        <Grid>
          <Grid.Col span="25%">
            <Skeleton variant="rounded" width={450} height={50} />
          </Grid.Col>
          <Grid.Col span="15%">
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
          <Grid.Col span="15%">
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span="15%">
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
          <Grid.Col span="15%">
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
        </Grid>
        <Grid>
          <Grid.Col span="65%">
            <Skeleton variant="rounded" width={850} height={50} />
          </Grid.Col>
          <Grid.Col>
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
        </Grid>
        <div style={{ height: '30px' }}></div>
        <Grid>
          <Grid.Col span="15%">
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
          <Grid.Col span="15%">
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
          <Grid.Col span="15%">
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
          <Grid.Col span="15%">
            <Skeleton variant="rounded" width={250} height={50} />
          </Grid.Col>
        </Grid>
      </Layout.Stack>
    </>
  );
};

export default FormSkeleton;
